export default {
  auth: {
    signIn: 'login',
    ad: 'auth/redirect',
    adLogout: 'auth/logout',
  },
  home: {
    mainPage: 'inicio',
  },
  conversations: {
    mainPage: 'conversas',
  },
  templates: {
    mainPage: 'templates',
  },
};
